import React, { useContext, useEffect, useMemo, useState } from 'react';

import Config from '@skin_config';

import FavoriteCompetitions from './components/favoriteCompetitions';
import FavoriteCompetitionsRemote from './components/favoriteCompetitions/remote';

import HomePopularGames from './components/popularGames';
import HomeCasinoGames from './components/casinoGames';

import MediaSlider from './components/mediaSlider';
import MediaSliderRemote from './components/mediaSlider/remote';

import HomeShortPages from './components/pages';
import HomeShortPagesRemote from './components/pages/remote';

import Banner from './components/banner';
import LiveGameBanner from './components/liveGameBanner';
import { PreferencesContext } from '@common/contexts/preferences';

import './style.scss';
import { useDataFetch } from '@common/hooks/dataFetch';
import _ from 'lodash';
import { BannerPositionEnum } from '@app/dev/constants/enums/banners';
import { getActiveBanners, getBannerList } from '@app/dev/helpers/banners';

const Home = () => {
  const [isVertical, setIsVertical] = useState(window.innerWidth < window.innerHeight);
  const [bannerData] = useDataFetch(Config.home.enableRemoteBanners ? getActiveBanners : () => null, []);
  const homeConfig = isVertical ? Config.verticalHome : Config.home;
  const templateAreas = homeConfig.grid.map((row) => `"${row.join(' ')}"`).join('');
  const hasSection = (sectionName) => homeConfig.grid.some((row) => row.includes(sectionName));
  const [{ lang }] = useContext(PreferencesContext);

  const perLanguageBannerData = useMemo(() => {
    if (!bannerData) return {};

    const newBannerData = _.cloneDeep(bannerData);
    Object.keys(newBannerData).forEach((key) => {
      newBannerData[key] = getBannerList(newBannerData[key], lang);
    });
    return newBannerData;
  }, [bannerData, lang]);

  useEffect(() => {
    const handleResize = () => setIsVertical(window.innerWidth < window.innerHeight);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  console.log(Config.main.homeBannerSlides, 'asdfasdfasdf');

  return (
    <section className="home-page">
      <div
        className="home-page"
        style={{
          gridTemplateAreas: templateAreas,
          gridTemplateColumns: homeConfig.gridColumns,
          gridTemplateRows: homeConfig.gridRows,
        }}
      >
        {hasSection('shortpages') && (
          Config.home.enableRemoteBanners
            ? <HomeShortPagesRemote slidesData={_.pick(perLanguageBannerData, BannerPositionEnum.UpperLeft, BannerPositionEnum.UpperCenter, BannerPositionEnum.UpperRight)} />
            : <HomeShortPages />
        )}

        {hasSection('slider') && (
          Config.home.enableRemoteBanners
            ? <MediaSliderRemote slides={perLanguageBannerData[BannerPositionEnum.Main]} />
            : <MediaSlider />
        )}

        {hasSection('banner') && <Banner slides={Config.home.enableRemoteBanners ? perLanguageBannerData[BannerPositionEnum.Right] : Config.main.homeBannerSlides} />}
        {hasSection('liveGameBanner') && <LiveGameBanner />}

        {hasSection('comp') && (
          Config.home.enableRemoteBanners
            ? <FavoriteCompetitionsRemote slidesData={_.pick(perLanguageBannerData, BannerPositionEnum.BottomLeft, BannerPositionEnum.BottomCenter, BannerPositionEnum.BottomRight)} />
            : <FavoriteCompetitions />
        )}

        {hasSection('populargames') && <HomePopularGames />}
        {hasSection('casinogames') && <HomeCasinoGames />}
      </div>
    </section>
  );
};

export default Home;
